import client from '@libs/HttpClient';
class RecruitmentSourcesService {
  static listRecruitmentSources(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    return client.get(
      `/recruitment-candidate-sources/?search=${searchText}&page=${page_no}&status=${status}`,
      request
    );
  }
  static addRecruitmentSources(request) {
    return client.post('/recruitment-candidate-sources', request);
  }
  static showRecruitmentSources(params) {
    return client.get(`/recruitment-candidate-sources/${params}`);
  }
  static viewRecruitmentSources(params) {
    return client.get(`/recruitment-candidate-sources/${params}/edit`);
  }
  static updateRecruitmentSources(request) {
    return client.put(`/recruitment-candidate-sources/${request.id}`, request);
  }
  static deleteRecruitmentSources(request) {
    return client.delete(`/recruitment-candidate-sources/${request.id}`, request);
  }
  static changeStatusRecruitmentSources(request) {
    return client.patch(`/recruitment-candidate-sources/change-status/${request.id}`, request);
  }
}
export { RecruitmentSourcesService };
